import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Package, FolderTree, Wrench, FileText, Newspaper, Inbox, AlertCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const AdminDashboard = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  const cards = [
    { label: "Products", value: stats?.products, icon: Package, link: "/admin/products" },
    { label: "Categories", value: stats?.categories, icon: FolderTree, link: "/admin/categories" },
    { label: "Services", value: stats?.services, icon: Wrench, link: "/admin/services" },
    { label: "Catalogues", value: stats?.catalogues, icon: FileText, link: "/admin/catalogues" },
    { label: "News Articles", value: stats?.news, icon: Newspaper, link: "/admin/news" },
    { label: "Inquiries (New)", value: stats?.new_inquiries, total: stats?.inquiries, icon: Inbox, link: "/admin/inquiries", highlight: true },
    { label: "Catalogue Leads", value: stats?.new_catalogue_requests, total: stats?.catalogue_requests, icon: Package, link: "/admin/catalogue-requests", highlight: true },
    { label: "Team Members", value: stats?.team, icon: FolderTree, link: "/admin/team" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="mb-8">
        <h1 className="font-display text-3xl text-[#0A1128]">Welcome back, {user?.name?.split(" ")[0]}</h1>
        <p className="text-slate-500 mt-1 text-sm">Here's your trade desk overview.</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {cards.map((c) => (
          <Link
            key={c.label}
            to={c.link}
            data-testid={`stat-card-${c.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
            className={`bg-white border ${c.highlight && c.value > 0 ? "border-[#D4AF37]" : "border-slate-200"} rounded-sm p-6 hover:-translate-y-1 hover:border-[#D4AF37] transition-all`}
          >
            <div className="flex items-start justify-between mb-5">
              <c.icon size={20} className="text-[#D4AF37]" />
              {c.highlight && c.value > 0 && <AlertCircle size={16} className="text-red-500" />}
            </div>
            <div className="font-display text-4xl text-[#0A1128]">
              {c.value ?? "—"}
              {c.total !== undefined && <span className="text-base text-slate-400"> / {c.total}</span>}
            </div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-slate-500 mt-2">{c.label}</div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AdminDashboard;
